import React from 'react'
import PropTypes from 'prop-types'
import {
  TextField,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
} from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import { useTranslation } from 'react-i18next'
import { AutocompleteTextField } from './CustomerStyledComponents'
const MaterialsList = ({
  materials,
  availableMaterials,
  handleAddMaterial,
  handleMaterialChange,
  handleRemoveMaterial,
  title,
  buttonTitle,
  type,
  isNotModifiable,
}) => {
  const { t } = useTranslation('order_modal')
  return (
    <div>
      <Grid container>
        <Grid item xs={2}>
          <Typography variant="h5">{title}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Button
            variant="outlined"
            color="primary"
            spacing={2}
            onClick={handleAddMaterial}
            disabled={isNotModifiable}
          >
            <span style={{ marginRight: '1rem' }}>+</span> {buttonTitle}
          </Button>
        </Grid>
      </Grid>
      <TableContainer component={Paper}>
        <Table>
          <TableBody>
            {materials.map((material, index) => (
              <TableRow key={index}>
                <TableCell width="40%">
                  <Autocomplete
                    options={availableMaterials}
                    getOptionLabel={(option) =>
                      option.internalId + ' - ' + option.description || ''
                    }
                    value={
                      availableMaterials.find((mat) => mat.internalId === material.internalId) ||
                      null
                    }
                    onChange={(event, value) =>
                      handleMaterialChange(index, 'name', value ? value.internalId : '', type)
                    }
                    renderInput={(params) => (
                      <AutocompleteTextField
                        {...params}
                        label={t('materialName')}
                        disabled={isNotModifiable}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props}>
                        {option.internalId} - {option.description}
                      </li>
                    )}
                    clearIcon={null}
                    disabled={isNotModifiable}
                    noOptionsText={t('noOptions')}
                    fullWidth
                    sx={{
                      '& svg': { position: 'static' },
                    }}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    label={t('quantity')}
                    value={material.quantity ?? 30}
                    onChange={(e) => {
                      const value = e.target.value
                      if (/^(?:\d+(\.\d{0,3})?)?$/.test(value)) {
                        handleMaterialChange(index, 'quantity', value, type)
                      }
                    }}
                    fullWidth
                    disabled={isNotModifiable}
                  />
                </TableCell>
                <TableCell>
                  <TextField label={t('unit')} value={material.unit} disabled fullWidth />
                </TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => handleRemoveMaterial(index, type)}
                    disabled={isNotModifiable}
                  >
                    x
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}
MaterialsList.propTypes = {
  materials: PropTypes.arrayOf(
    PropTypes.shape({
      internalId: PropTypes.string.isRequired,
      quantity: PropTypes.string.isRequired,
      unit: PropTypes.string.isRequired,
    })
  ).isRequired,
  availableMaterials: PropTypes.arrayOf(
    PropTypes.shape({
      internalId: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      unit: PropTypes.string.isRequired,
    })
  ).isRequired,
  handleAddMaterial: PropTypes.func.isRequired,
  handleMaterialChange: PropTypes.func.isRequired,
  handleRemoveMaterial: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  buttonTitle: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  isNotModifiable: PropTypes.bool,
}
export default MaterialsList
